<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import axios from 'axios'

    import VirtualList from '../../components/VirtualList/VirtualList.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import ListFilter from './ListFilter.svelte'

    export let height = '360px'
    
    let items   = null,
        favs    = []

    const dispatch = createEventDispatcher ();

    const onListFilter = (event) => {
        const { value } = event.detail;

        if (value.length < 3) {
            items = favs;
        } else {
            dispatch ('app-event', { id: 'background', value: true });
            axios.request ({
                method: 'post',
                url: '/api/programs/searchWorks',
                params: {
                    segment: value
                }
            }).then (result => {
                items = result.data;
                dispatch ('app-event', { id: 'background', value: false });
            }).catch (e => {
                dispatch ('app-event', { id: 'app-error', error: e });
            })
        }
    }

    onMount (() => {
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'post',
            url: '/api/programs/listWorks'
        }).then (result => {
            items = result.data;
            favs = items;
            dispatch ('app-event', { id: 'background', value: false });
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    })
</script>

<style>
    .ListChooser :global(svelte-virtual-list-viewport) {
        padding: 10px;
    }
</style>

{#if items}
    <div class="ListChooser">
        <ListFilter on:filter={onListFilter} />
        <!-- <FadeinFX durationOut={0}> -->
            <VirtualList {items} {height} let:item>
                <div class="OperatorItem clearfix">
                    <ListItem classes="block with-icon clearfix" actions on:click={e => dispatch ('select', item)}>
                        <div class="icon">
                            <i class="fad fa-vacuum"></i>
                        </div>
                        <div class="meta">
                            <div class="lbl">Lavorazione</div>
                            <div class="txt">{item.description}</div>
                        </div>
                        
                        <div slot="actions">
                            <ActionButton icon="far fa-arrow-left" on:click={e => dispatch ('select', item)} />
                        </div>
                    </ListItem>
                </div>
            </VirtualList>
        <!-- </FadeinFX> -->
    </div>
{/if}